require('./dist/details/details.css');
